function fallbacks() {
  const meta = document.querySelector('meta[name="locale-fallbacks"]');
  const chain = meta?.content || document.documentElement.lang || '';

  return chain
    .split(',')
    .map((locale) => locale.trim())
    .filter(Boolean);
}

function present(value) {
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === 'object') return Object.keys(value).length > 0;

  return Boolean(value);
}

function isTranslations(translations) {
  return (
    Boolean(translations) &&
    typeof translations === 'object' &&
    !Array.isArray(translations)
  );
}

export function translate(translations) {
  if (!isTranslations(translations)) return undefined;

  return fallbacks()
    .map((locale) => translations[locale])
    .find(present);
}

// Settles for any translation rather than nothing, so a record stays named even
// in a language it was never written in.
export function translateOrFirst(translations) {
  if (!isTranslations(translations)) return undefined;

  return translate(translations) ?? Object.values(translations).find(present);
}
